export default "__VITE_ASSET__8a7bfa6b__"